// extracted by mini-css-extract-plugin
export default {"label":"showAssignedAssets_label__tqndm","listData":"showAssignedAssets_listData__LSTeD","listBtn":"showAssignedAssets_listBtn__7lM95"};